/* eslint-disable max-len */
import { SvgProps } from './types'

export const DollarRisingIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <circle cx="15.35" cy="18.6" r="11.2" stroke={drawColor} strokeWidth="2" />
      <path
        d="M11.15 34.29A16.24 16.24 0 0 0 31.59 18.6V5.16"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.33 9.42L31.59 5.16L35.85 9.42"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.95 15.63C16.83 12.64 11.77 12.99 11.72 16.11C11.71 17.5 13.35 18.15 14.71 18.36C19.68 19.15 18.31 23.83 14.71 23.65C11.98 23.52 11.18 21.67 11.09 21.22"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.77 11.06V13.57" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.77 23.66V26.17" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
